import React, {useContext} from 'react';
import ChecklistFilter from '@views/orders/ChecklistFilter';
import OrderProductsChecklists from '@views/orders/fields/products/extra_row/OrderProductsChecklists';
import {FormFieldItemPropsContext} from '@src/contexts/FormFieldItemPropsContext';

type TProps = React.ComponentProps<typeof OrderProductsChecklists>
        & Pick<Required<React.ComponentProps<typeof ChecklistFilter>>, 'toggleTabVisibility'> &
        {
            display: boolean,
        };

const emptyArray: never[] = [];

export default function OrderProductChecklistsTabManager(props: TProps) {
    const {display, toggleTabVisibility, ...rest} = props;
    const {modelOptions} = useContext(FormFieldItemPropsContext) ?? {};

    return <ChecklistFilter
            productId={props.rowRecord.product_id}
            checklists={(props.modelOptions ?? modelOptions)?.checklists ?? emptyArray}
            currentStatusId={props.entityStatusId}
            displayOnlyWithType="for-order-product"
            toggleTabVisibility={toggleTabVisibility}
    >{() => {
        if (!display) {
            return null;
        }

        return <OrderProductsChecklists {...rest}/>;
    }}</ChecklistFilter>;
}
